import React, { useEffect } from 'react';
import "./elfsight-widget.style.scss";
const ElfsightWidget = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://static.elfsight.com/platform/platform.js';
        script.async = true;
        document.body.appendChild(script);
        const hideElfsightLink = () => {
            const link = document.querySelector('.elfsight-app-5987b959-a851-4215-b971-017c629d2f0e > a[title]');
            if (link) {
                link.style.display = 'none';
            }
        };

        script.onload = () => {
            setTimeout(hideElfsightLink, 2000);
        };
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="elfsight-widget-section">
            <div className="elfsight-widget-headline">

            <h2 className="section-slider_h2__wrapper muur-h2__wrapper">
                <div className="muur-h2 section-slider_headline secondary-bg white-color aos-init aos-animate"
                     data-aos="fade-up">muur bei Instagram
                </div>
            </h2>
            </div>
            <div
                className="elfsight-app-5987b959-a851-4215-b971-017c629d2f0e"
                data-elfsight-app-lazy
            ></div>
        </div>
    );
};

export default ElfsightWidget;
